import React__default from 'react';
import PropTypes from 'prop-types';
import { AlertContainer, IconContainer, AlertContent, AlertContentChildren, CloseButtonContainer } from './Alert.styles.js';
import { Icon } from '../Icon/Icon.js';
import Typography from '../Typography/index.js';
import ButtonIcon from '../Inputs/Button/ButtonIcon/ButtonIcon.js';
import { FEEDBACK_ICONS } from '../../constants/feedback.js';

var Alert = function Alert(_ref) {
  var children = _ref.children,
    _ref$onDismiss = _ref.onDismiss,
    onDismiss = _ref$onDismiss === void 0 ? undefined : _ref$onDismiss,
    _ref$onDismissTitle = _ref.onDismissTitle,
    onDismissTitle = _ref$onDismissTitle === void 0 ? 'close message' : _ref$onDismissTitle,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? undefined : _ref$title,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'info' : _ref$type,
    _ref$isFullWidth = _ref.isFullWidth,
    isFullWidth = _ref$isFullWidth === void 0 ? true : _ref$isFullWidth,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var hasTitle = !!title;
  return React__default.createElement(AlertContainer, {
    $type: type,
    $isFullWidth: isFullWidth,
    role: "alert",
    "data-testid": testId
  }, React__default.createElement(IconContainer, {
    $type: type
  }, React__default.createElement(Icon, {
    variant: FEEDBACK_ICONS[type]
  })), React__default.createElement(AlertContent, null, hasTitle && React__default.createElement(Typography, {
    variant: "headingMedium"
  }, title), React__default.createElement(Typography, {
    variant: "bodyMedium",
    as: AlertContentChildren
  }, children)), typeof onDismiss === 'function' && React__default.createElement(CloseButtonContainer, {
    $isPositionTop: hasTitle
  }, React__default.createElement(ButtonIcon, {
    icon: "Close",
    variant: "ghost",
    size: "tiny",
    onClick: onDismiss
  }, onDismissTitle)));
};
Alert.propTypes = {
  children: PropTypes.node.isRequired,
  isFullWidth: PropTypes.bool,
  onDismiss: PropTypes.func,
  onDismissTitle: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(['info', 'warning', 'error', 'success'])
};
var Alert$1 = Alert;

export { Alert$1 as default };
//# sourceMappingURL=Alert.js.map
